// Angular
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { OverlayModule } from '@angular/cdk/overlay';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { NgxPermissionsModule } from 'ngx-permissions';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { MatCardModule } from '@angular/material/card';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';
import { ThemeModule } from "./views/theme/theme.module";
import { PartialsModule } from './views/partials/partials.module';
import {
	KtDialogService,
	LayoutConfigService,
	LayoutRefService,
	MenuAsideService,
	MenuConfigService,
	MenuHorizontalService,
	PageConfigService,
} from './core/_base/layout';
import { AuthModule } from './views/pages/auth/auth.module';
import { AuthService } from './core/auth';
import { HttpUtilsService, LayoutUtilsService, TypesUtilsService } from './core/_base/crud';
import { HIGHLIGHT_OPTIONS } from 'ngx-highlightjs';
// import * as typescript from 'highlight.js/lib/languages/typescript';
// import * as scss from 'highlight.js/lib/languages/scss';
// import * as xml from 'highlight.js/lib/languages/xml';
// import * as json from 'highlight.js/lib/languages/json';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ExcelService } from './services/excelservice';
import { LoaderComponent } from './views/pages/loader/loader.component';
import { SharedModule } from './views/pages/shared.module';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { NgOtpInputModule } from  'ng-otp-input';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
// import { NgxOtpInputModule } from "ngx-otp-input";


// export function hljsLanguages(): HighlightLanguage[] {
// 	return [
// 		{ name: 'typescript', func: typescript },
// 		{ name: 'scss', func: scss },
// 		{ name: 'xml', func: xml },
// 		{ name: 'json', func: json }
// 	];
// }
@NgModule({
	declarations: [AppComponent,LoaderComponent],
	imports: [
		BrowserAnimationsModule,
		AppRoutingModule,
		SharedModule,
		ThemeModule,
		NgxPermissionsModule.forRoot(),
		PartialsModule,
		CoreModule,
		OverlayModule,
		StoreModule.forRoot({}),
		EffectsModule.forRoot([]),
		AuthModule.forRoot(),
		NgbModule,
		PerfectScrollbarModule,
		MatCardModule,
		MatProgressSpinnerModule,
		MatSortModule,
		MatPaginatorModule,
		NgOtpInputModule,
  ServiceWorkerModule.register('ngsw-worker.js', {
    enabled: environment.production,
    // Register the ServiceWorker as soon as the app is stable
    // or after 30 seconds (whichever comes first).
    registrationStrategy: 'registerWhenStable:30000'
  }),
		// NgxOtpInputModule
		],
	exports: [SharedModule],
	providers: [
		AuthService,
		LayoutConfigService,
		LayoutRefService,
		KtDialogService,
		// NgbTabset,
		{
			provide: HIGHLIGHT_OPTIONS,
			useValue: {
			  coreLibraryLoader: () => import('highlight.js/lib/core'),
			  languages: {
				typescript: () => import('highlight.js/lib/languages/typescript'),
				css: () => import('highlight.js/lib/languages/css'),
				xml: () => import('highlight.js/lib/languages/xml'),
				json: () => import('highlight.js/lib/languages/json')
			  }
			}
		  },
		MenuHorizontalService,
		PageConfigService,
		MenuConfigService,
		MenuAsideService,
		HttpUtilsService,
		TypesUtilsService,
		LayoutUtilsService,
		ExcelService, { provide: LocationStrategy, useClass: HashLocationStrategy },
		ThemeModule
	],
	bootstrap: [AppComponent]
})
export class AppModule {
}